import currency from "currency.js";

export const formatCurrency = (
  value: string | number | undefined,
  precision = 0
) => {
  let amount = value;
  if (!amount) amount = 0;

  return currency(amount, {
    separator: ",",
    precision,
  }).format();
};

export const monthlyAmountToBiWeekly = (inputValue: number) => {
  return (inputValue * 12) / 26;
};

export const monthlyAmountToWeekly = (inputValue: number) => {
  return (inputValue * 12) / 52;
};
